import { c as _c } from "react/compiler-runtime";
import { useNotificationPresentationConfig } from './Flyout/NotificationsFlyout/useNotificationPresentationConfig';
import Grid from '@precis-digital/kurama/Grid';
import { styled } from '@precis-digital/kurama/utils';
import Typography from '@precis-digital/kurama/Typography';
import Badge from '@precis-digital/kurama/Badge';
import React from 'react';
import { StyledGraySpan } from './Flyout/styles';
import { type DisplayNotification } from './Flyout/NotificationsFlyout/utils';
interface NotificationCardProps {
  title: string;
  description: string;
  type: DisplayNotification['source'];
  date: DisplayNotification['createdAt'];
  isRead: boolean;
}
const NotificationCard: React.FC<NotificationCardProps> = t0 => {
  const $ = _c(23);
  const {
    title,
    description,
    type,
    date,
    isRead
  } = t0;
  const notificationPresentationConfig = useNotificationPresentationConfig();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginRight: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = notificationPresentationConfig[type];
  let t3;
  if ($[1] !== t2.icon) {
    t3 = <Grid item={true} sx={t1}>{t2.icon}</Grid>;
    $[1] = t2.icon;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <Grid item={true}><Typography variant="h4">{title}</Typography></Grid>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isRead) {
    t5 = !isRead && <Grid item={true} sx={{
      ml: "auto"
    }}><Badge color="info" /></Grid>;
    $[5] = isRead;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Grid item={true}><Grid container={true} alignItems="center" wrap="nowrap" spacing={1}>{t4}{t5}</Grid></Grid>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== date) {
    t7 = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      day: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit"
    }).format(date);
    $[10] = date;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <Grid item={true}><Typography variant="body3"><StyledGraySpan>{t7}</StyledGraySpan></Typography></Grid>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== description) {
    t9 = <Grid item={true}><Typography variant="body2"><StyledGraySpan>{description}</StyledGraySpan></Typography></Grid>;
    $[14] = description;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t8 || $[18] !== t9) {
    t10 = <Grid item={true} xs={true}><Grid container={true} direction="column">{t6}{t8}{t9}</Grid></Grid>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t3) {
    t11 = <StyledNotificationCard container={true}>{t3}{t10}</StyledNotificationCard>;
    $[20] = t10;
    $[21] = t3;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const content = t11;
  return content;
};
const StyledNotificationCard = styled(Grid)<{
  $path?: string;
}>(({
  theme
}) => ({
  margin: '0 -12px',
  width: 'calc(100% + 24px)',
  padding: '12px 12px',
  borderRadius: theme.borderRadius.xLarge,
  cursor: 'pointer',
  ':hover': {
    backgroundColor: theme.tokens.background.tonal.soft.default
  }
}));
export default NotificationCard;